import React, {useState} from 'react';
import LoginElement, {ILoginElementProps} from "./LoginElement";
import {Container} from "@mui/material";

import useUser from "../auth/useUser";


const LoginComponent = (props: ILoginElementProps) => {
  const [user, userActions] = useUser();


  return (
    <>

      <Container maxWidth={'xs'} hidden={user.isAuthenticated}>
        <LoginElement
          type="login"
          onLogin={() => {window.location.reload();}}
        ></LoginElement>
      </Container>
    </>
  );
};

export default LoginComponent;

